import React from 'react';
import { WHATSAPP_NUMBER } from '../config';

const FloatingWhatsAppButton: React.FC = () => {
  const number = WHATSAPP_NUMBER;
  const message = encodeURIComponent('Olá! Gostaria de conhecer melhor os produtos Tratty.');
  const href = `https://wa.me/${number}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Falar no WhatsApp"
      className="floating-social-btn floating-whatsapp-btn"
      onClick={() => {
        import('../utils/analytics').then(m => m.trackClickWhatsApp('floating')).catch(() => {});
      }}
    >
      <i className="bi bi-whatsapp" aria-hidden="true"></i>
    </a>
  );
};

export default FloatingWhatsAppButton;
